/** Relative time, initials and small number helpers, ported verbatim from the
 *  original design component so the wording on screen does not change. */

export function rel(iso: string | null | undefined): string {
  if (!iso) return '-'
  const s = (Date.now() - new Date(iso).getTime()) / 1000
  if (s < 0) return 'just now'
  if (s < 90) return 'just now'
  const m = s / 60
  if (m < 60) return Math.floor(m) + 'm ago'
  const h = m / 60
  if (h < 24) return Math.floor(h) + 'h ago'
  const d = h / 24
  if (d < 30) return Math.floor(d) + 'd ago'
  return Math.floor(d / 30) + 'mo ago'
}

export function initials(name: string): string {
  return name
    .split(/[\s._-]+/)
    .filter(Boolean)
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()
}

export const num = (n: number) => n.toLocaleString('en-US')

/** The host to show on a "visit deployment" link, without scheme or trailing slash. */
export function hostname(url: string): string {
  try {
    return new URL(url).host
  } catch {
    return url
  }
}
